// Axios
import gql from 'graphql-tag'

export const GET_VEHICLE_STATUSES = gql`
query VehicleStatuses($filter: GetVehicleStatusesInput) {
  vehicleStatuses(filter: $filter) {
    message
    isSuccessful
    vehicleStatuses {
      vehicleId
      longitude
      licensePlate
      latitude
      temperature
      speed
      calculatedSpeed
      engineOn
      direction
      currentGeofences {
        geofence {
          fenceName
        }
        timeInGeofence
      }
      vehicle {
        hullNo
        imei
        driver1 {
          phoneNo
          fullname
        }
        vehicleType {
          category
          type
        }
        device {
          identifier
          phoneNo
          deviceName
        }
      }
      lastPacket
      sumDistance
      sumDrivetime
      fuelFiltered
      fuelCapacity
      motionStatus
      calculatedMotionStatus
      signalStrength
      tripstartOn
      tripDistance
      tripDrivetime
      timeInStatus
      sumDrivetimeFormatted
    }
  }
}
`

export const GET_VEHICLE_IN_FENCE = gql`
query VehiclesInFence($filter: VehiclesInFenceFilter) {
  vehiclesInFence(filter: $filter) {
    isSuccessful
    message
    vehiclesInFence {
      totalVehicle
      geofence {
        fenceName
        polyData
        circData
        type
        province
        city
        phoneNo
        contactName
      }
      totalGroup
      vgroup {
        id
        name
        vehicles {
          timeInGeofence
          vehicle {
            id
            driver1 {
              fullname
            }
            licensePlate
            hullNo
            imei
            device {
              deviceName
            }
            vehicleType {
              category
              type
            }
          }
        }
      }
    }
  }
}
`

export const GET_SUMMARY_TRIP = gql`
query SummaryTrips($filter: SummaryTripsFilter!) {
  summaryTrips(filter: $filter) {
    isSuccessful
    message
    summaryTrips {
      summaryTrips {
        vehicleId
        tripMileage
        startLong
        startLat
        stopLong
        stopLat
        maxSpeed
        startTime
        stopTime
        totalHourStart
        totalHourStop
        type
        driver {
          fullname
        }
      }
      totalTrip
      totalHourStart
      totalHourStop
      totalAssistedTripDistance
      totalAssistedTripDuration
      totalMovingTripDistance
      totalMovingTripDuration
    }
  }
}
`

export const GET_LAST_SUMMARY_TRIP = gql`
query LastSummaryTrip($filter: LastSummaryTripsFilter) {
  lastSummaryTrip(filter: $filter) {
    isSuccessful
    message
    lastSummaryTrips {
      summaryTrips {
        startTime
        stopTime
        vehicleId
        tripMileage
        startLong
        startLat
        stopLong
        stopLat
        maxSpeed
        totalHourStart
        totalHourStop
      }
      totalTrip
      totalHourStart
      totalHourStop
      motionStatus
    }
  }
}
`

export const GET_RAW_LOCATION = gql`
query RawLocations($filter: GetRawLocationsFilter!) {
  rawLocations(filter: $filter) {
    isSuccessful
    message
    rawLocations {
      sentOn
      latitude
      longitude
      vehicleId
      speed
      direction
    }
  }
}
`

export const GET_RAW_ALERTS = gql`
query RawAlerts($filter: GetRawAlertFilter!) {
  rawAlerts(filter: $filter) {
    isSuccessful
    message
    rawAlerts {
      data{
        address
        createdOn
        vehicleId
        alertFlag
        alertData
        formattedAlertData
        latitude
        longitude
        alertTrigger
        threshold
        cost
        driver {
          fullname
        }
        alert {
          alertCode
          descriptionEng
          descriptionIdn
        }
        vehicle {
          licensePlate
          imei
          vehicleType {
            type
            category
          }
          device {
            identifier
            phoneNo
            deviceName
          }
        }
      }
      pagination {
        total
        page
        show
        startCursor
        endCursor
      }
    }
  }
}
`

export const SET_ENGINE_STATUS = gql`
mutation SetEngineStatus($input: SetEngineStatusInput) {
  setEngineStatus(input: $input) {
    isSuccessful
    message
    setEngineStatus {
      currentEngineStatus
      commandStatus
    }
  }
}
`

export const REGISTER_CALL_NUMBER = gql`
mutation RegisterCallNumber($input: RegisterCallNumberInput!) {
  registerCallNumber(input: $input) {
    isSuccessful
    message
    registerCallNumber {
      imei
      phoneNumber
    }
  }
}
`
